<div class="toast-host">
  <ng-container *ngIf="toasts$ | async as toasts">
    <div class="toast-slot" *ngFor="let t of toasts; trackBy: trackById">
      <app-toast-item [toast]="t"></app-toast-item>
    </div>
  </ng-container>
</div>
